import { lazy } from 'react';
import { RouteConfig } from './types';

const Home = lazy(() => import('../pages/Home'));
const Blog = lazy(() => import('../pages/Blog'));
const BlogPost = lazy(() => import('../pages/BlogPost'));
const Blxxnk = lazy(() => import('../pages/Blxxnk'));
const Donivan = lazy(() => import('../pages/Donivan'));
const Commissions = lazy(() => import('../pages/Commissions'));
const ContactPage = lazy(() => import('../pages/ContactPage'));
const Mission = lazy(() => import('../pages/Mission'));
const MissionStatusPage = lazy(() => import('../pages/MissionStatusPage'));
const SecretMissions = lazy(() => import('../pages/SecretMissions'));
const OrbitalOperations = lazy(() => import('../pages/OrbitalOperations'));
const OrbitalExpeditions = lazy(() => import('../pages/OrbitalExpeditions'));
const Shop = lazy(() => import('../pages/Shop'));
const Vault = lazy(() => import('../pages/Vault'));

export const routes: RouteConfig[] = [
  {
    path: '/',
    component: Home,
  },
  {
    path: '/blog',
    component: Blog,
  },
  {
    path: '/blog/:slug',
    component: BlogPost,
  },
  {
    path: '/blxxnk',
    component: Blxxnk,
  },
  {
    path: '/donivan',
    component: Donivan,
  },
  {
    path: '/commissions',
    component: Commissions,
  },
  {
    path: '/contact',
    component: ContactPage,
  },
  {
    path: '/mission',
    component: Mission,
  },
  {
    path: '/mission-status',
    component: MissionStatusPage,
  },
  {
    path: '/secret-missions',
    component: SecretMissions,
  },
  {
    path: '/orbital-operations',
    component: OrbitalOperations,
  },
  {
    path: '/orbital-expeditions',
    component: OrbitalExpeditions,
  },
  {
    path: '/shop',
    component: Shop,
  },
  {
    path: '/vault',
    component: Vault,
  },
];
